module.exports = function (fox) {
	"use strict";

	require('./stylus/_userProfile.styl');
	require('fox-dynamic-injection!fox-template-loader!./templates.tpl')(fox);
	require('./widget/userProfile.js')(fox);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-profile/index.js
// module id = 584
// module chunks = 4